import React, {createContext, useContext, useEffect, useState} from 'react';
import {request} from '../api';
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);
export function AuthProvider({children}) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const showError = event => setError(event.detail);
    window.addEventListener('rental-error', showError);
    fetch('/api/me', {credentials:'include'}).then(async response => {
      if(response.status === 401) return;
      if(!response.ok) throw new Error('VentES sign-in is temporarily unavailable.');
      const user=await response.json();setCurrentUser({...user,uid:user.sub});
    }).catch(e=>setError(e.message)).finally(()=>setLoading(false));
    return () => window.removeEventListener('rental-error', showError);
  }, []);
  const login = () => {window.location.href='/api/auth/login';};
  const logout = async () => {await request('/logout','POST',{});setCurrentUser(null);window.location.href='/';};
  const userRole = ['OWNER','ADMIN'].includes(currentUser?.organization_role) ? 'admin' : 'user';
  return <AuthContext.Provider value={{currentUser,userRole,login,signup:login,logout}}>
    {error && <div role="alert" className="p-4 bg-red-100">{error} <button onClick={()=>setError('')}>Dismiss</button> <a href="/api/auth/login">Sign in again</a></div>}
    {loading ? <p className="p-8">Loading workspace…</p> : children}
  </AuthContext.Provider>;
}
